<div class="header-padding">
	<div class="header-container">
		<div class="report-info">
			<h2 class="report-title">Blast Design</h2>
			<p class="report-subtitle">
				<span class="subtitle-span">Burden & Spacing Table view</span> - visualizes average spacing, face burdens & pattern
				burdens in a tabular form
			</p>
		</div>
		<div class="export-btn">
			<button mat-raised-button color="primary" class="export-pdf-btn" (click)="addDesignBurdens()"
				[disabled]="!dataSource?.data?.length">
				Save Design Burdens
			</button>
		</div>
	</div>
</div>
<div class="excel-style-container">
	<div class="table-content">
		<table mat-table [dataSource]="dataSource" matSort class="data mat-elevation-z1 excel-table">

			<!-- Project Column -->
			<ng-container matColumnDef="project">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Project </th>
				<td mat-cell *matCellDef="let element"> {{element.project}} </td>
			</ng-container>

			<!-- Average Burden Column -->
			<ng-container matColumnDef="averageBurden">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>
					{{ 'Average Pattern Burden' | UnitDisplayPipe: userUnitMeasurement : 'distance' }}
				</th>
				<td mat-cell *matCellDef="let element"> {{element.averageBurden}} </td>
			</ng-container>
		
			<!-- Design Burden Column -->
			<ng-container matColumnDef="designBurden">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>
					{{ 'Design Burden' | UnitDisplayPipe: userUnitMeasurement : 'distance' }}
				</th>
				<td mat-cell *matCellDef="let element">
					<input matInput type="number" [(ngModel)]="element.designBurden" (change)="onInputChange()"
						class="excel-input">
				</td>
			</ng-container>
		
			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
		</table>
		
		<!-- Paginator -->
		<mat-paginator pageSize="30" [pageSizeOptions]="[30, 40]" hidePageSize="true">
		</mat-paginator>
		
		<ng-container *ngIf="loading">
			<div class="loading-logo">
			<mat-spinner></mat-spinner>
			</div>
		</ng-container>
	</div>	  
</div>